import { Text, Link, Heading } from '@chakra-ui/react';
import React, { FC, useEffect, useState } from 'react';
import { Order } from '../API';
import { CalendarApi } from '../API/sdk';
import { Link as RouteLink } from 'react-router-dom';
import { pages } from '../Constants/Pages';
import { useTranslation } from 'react-i18next';

export const CalenderProductListPage: FC = (props) => {
	const [list, setList] = useState<null | Order[]>();
	const { t } = useTranslation('calendar');

	const updateSettings = async () => {
		const result = await CalendarApi.getCustomerCalendarProducts();
		result.data && setList(result.data);

		// if (result.data && result.data.length === 1) {
		// 	alert('Asiakkaalla vain yksi kalenterituote, ohjataan suoraan kalenteriin');
		// }
	};

	useEffect(() => {
		updateSettings();
	}, []);

	return (
		<div>
			<Heading as="h3" fontSize="lg">
				{t('Kalenterituotteet')}
			</Heading>

			{list &&
				list.map((item, i) => (
					<Link
						key={i}
						as={RouteLink}
						to={`${pages.broadband}/${item.orderId}/${item.orderRowId}`}
						{...linkProps}
					>
						<Text as="span" d="flex" justifyContent="space-between" fontSize="md">
							<b>{item.productName}</b>
							<span>{item.address}</span>
						</Text>
					</Link>
				))}
		</div>
	);
};

const linkProps = {
	borderRadius: 4,
	d: 'block',
	py: 2,
	px: 2,
	mt: 2,
	bg: 'blue.50',
	_hover: {
		bg: 'blue.100'
	}
};
